import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'posfilter',
  pure: true
})
export class posFilterPipe implements PipeTransform {
  transform(items: any[], filter: string|string[]): any {

    if (!items || !filter) {
      return [-1];
    }

    if(typeof filter === "string") {
      return items.filter(item => item?.address?.town.toLowerCase().indexOf(filter.toLowerCase()) !== -1);
    }
    else {
      items = items.filter((item) => {
        return filter.includes(item.name);
      });

      if(items.length > 0) {
        return items.sort((a, b) => {
          return filter.indexOf(a.name) - filter.indexOf(b.name);
        });
      }
      else {
        return [-1];
      }
    }
  }
}
